import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles/checkoutRowContainer.scss';

const CheckoutRowContainer = ({
    wrapperClass,
    isClickable = true,
    isSelected = false,
    isDisabled = false,
    noMargin = false,
    children,
    noHorizontalPadding,
    noPadding,
}) => {
    const wrapperClasses = classNames({
        [styles.wrapper]: true,
        [styles.clickable]: isClickable,
        [styles.selected]: isSelected,
        [styles.disabled]: isDisabled,
        [styles.noMargin]: noMargin,
        [wrapperClass]: true,
        [styles.noHorizontalPadding]: noHorizontalPadding,
        [styles.noPadding]: noPadding,
    });
    return (
        <div className={wrapperClasses} data-tn="checkout-row-container">
            {children}
        </div>
    );
};

CheckoutRowContainer.propTypes = {
    wrapperClass: PropTypes.string,
    isClickable: PropTypes.bool,
    isSelected: PropTypes.bool,
    isDisabled: PropTypes.bool,
    noMargin: PropTypes.bool,
    children: PropTypes.node,
    noHorizontalPadding: PropTypes.bool,
    noPadding: PropTypes.bool,
};

export default CheckoutRowContainer;
